<div>
  <mat-card *ngIf="user && country">
    <mat-card-title>
      <h1>
        <span>Country | </span><span class="country"> {{user.weeeSystem.country.name}}</span>
        <app-help-icon-button [code]="this.keyFigures === 'Put On Market' ? 'keyfigureentry.Country.PutOnMarket' : 'keyfigureentry.Country.Collected'"></app-help-icon-button>
      </h1>
    </mat-card-title>
  </mat-card>
  <mat-card *ngIf="user && !country">
    <mat-card-title>
      <h1>
        <span>WEEE System | </span><span class="country"> {{user.weeeSystem.description}}</span>
        <app-help-icon-button
          [code]="this.keyFigures === 'Put On Market'
          ? 'keyfigureentry.WeeeSystem.PutOnMarket'
          : (this.keyFigures === 'Collected'
              ? 'keyfigureentry.WeeeSystem.Collected'
              : (this.keyFigures === 'Cost'
                ? 'keyfigureentry.WeeeSystem.Cost'
                : (this.keyFigures === 'Recycling' ? 'keyfigureentry.WeeeSystem.Recycling' : 'keyfigureentry.WeeeSystem.All')))">
        </app-help-icon-button>
      </h1>
    </mat-card-title>
  </mat-card>
  <app-kf-registration-filter
    (search)="searchKfRegistration($event)">
  </app-kf-registration-filter>
  <mat-divider></mat-divider>
  <app-kf-registration-table *ngIf="kfRegistrationPage"
    [page]="kfRegistrationPage.number"
    [pageSize]="kfRegistrationPage.size"
    [totalElements]="kfRegistrationPage.totalElements"
    [kfRegistration]="kfRegistrationPage.content"
    (loadKfRegistrations)="loadKfRegistration($event)">
  </app-kf-registration-table>
</div>
